// Lightweight i18n - Turkish (default) + English. Extensible to more languages.
export const TRANSLATIONS = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      products: "Ürünler",
      categories: "Kategoriler",
      rates: "Döviz & Altın",
      tv: "TV Modu",
      about: "Hakkımızda",
      account: "Hesabım",
      cart: "Sepet",
      login: "Giriş Yap",
      register: "Üye Ol",
      logout: "Çıkış",
      admin: "Yönetim",
      favorites: "Favoriler",
    },
    home: {
      shop: "Koleksiyonu Keşfet",
      learn: "Daha Fazla",
      featured: "Öne Çıkan Ürünler",
      new: "Yeni Gelenler",
      bestsellers: "Çok Satanlar",
      categories: "Kategoriler",
      about_title: "2010'dan Beri Trabzon Çaykara'da",
      newsletter_title: "Bültenimize Katılın",
      newsletter_sub: "Yeni koleksiyon ve özel kampanyalardan haberdar olun",
      newsletter_btn: "Abone Ol",
      email_placeholder: "E-posta adresiniz",
      instagram_title: "Instagram'da Bizi Takip Edin",
    },
    product: {
      add_to_cart: "Sepete Ekle",
      add_to_fav: "Favorilere Ekle",
      stock: "Stok",
      in_stock: "Stokta var",
      out_of_stock: "Tükendi",
      sku: "SKU",
      code: "Kod",
      price: "Fiyat",
      related: "Benzer Ürünler",
      features: "Özellikler",
      description: "Açıklama",
    },
    cart: {
      title: "Sepetim",
      empty: "Sepetiniz boş",
      subtotal: "Ara Toplam",
      shipping: "Kargo",
      total: "Toplam",
      checkout: "Siparişi Tamamla",
      continue: "Alışverişe Devam",
      remove: "Kaldır",
      qty: "Adet",
    },
    checkout: {
      title: "Sipariş Onayı",
      address: "Teslimat Adresi",
      payment: "Ödeme Yöntemi",
      bank: "Havale / EFT",
      place_order: "Siparişi Ver",
      success: "Siparişiniz alındı!",
      full_name: "Ad Soyad",
      phone: "Telefon",
      city: "Şehir",
      district: "İlçe",
      addr_text: "Adres",
      postal: "Posta Kodu",
      addr_title: "Adres Başlığı",
    },
    auth: {
      login_title: "Giriş Yap",
      register_title: "Üye Ol",
      email: "E-posta",
      password: "Şifre",
      name: "Adınız",
      submit_login: "Giriş Yap",
      submit_register: "Üye Ol",
      no_account: "Hesabınız yok mu?",
      have_account: "Zaten üye misiniz?",
    },
    rates: {
      title: "Döviz & Altın Fiyatları",
      sub: "TCMB ve Nadir Döviz verilerine göre canlı kurlar",
      currency: "Döviz",
      gold: "Altın",
      silver: "Gümüş",
      buy: "Alış",
      sell: "Satış",
      last_update: "Son Güncelleme",
    },
    tv: {
      live: "CANLI",
      currencies: "DÖVİZ",
      gold: "ALTIN",
      silver: "GÜMÜŞ",
    },
    admin: {
      dashboard: "Panel",
      products: "Ürünler",
      categories: "Kategoriler",
      orders: "Siparişler",
      customers: "Müşteriler",
      settings: "Ayarlar",
      margins: "Marjlar",
      homepage: "Anasayfa",
      add_product: "Ürün Ekle",
      add_category: "Kategori Ekle",
      save: "Kaydet",
      cancel: "İptal",
      edit: "Düzenle",
      delete: "Sil",
      name: "Ad",
      price: "Fiyat",
      stock: "Stok",
      status: "Durum",
      actions: "İşlemler",
    },
    common: {
      view_details: "Detayları Gör",
      view_all: "Tümünü Gör",
      loading: "Yükleniyor...",
      search: "Ürün ara...",
      sort: "Sırala",
      filter: "Filtrele",
    },
  },
  en: {
    nav: { home: "Home", products: "Products", categories: "Categories", rates: "Currency & Gold", tv: "TV Mode", about: "About", account: "Account", cart: "Cart", login: "Sign In", register: "Register", logout: "Logout", admin: "Admin", favorites: "Favorites" },
    home: { shop: "Shop the Collection", learn: "Learn More", featured: "Featured", new: "New Arrivals", bestsellers: "Best Sellers", categories: "Categories", about_title: "Crafting Excellence Since 2010", newsletter_title: "Join Our Newsletter", newsletter_sub: "Be the first to know about new collections", newsletter_btn: "Subscribe", email_placeholder: "Your email address", instagram_title: "Follow Us on Instagram" },
    product: { add_to_cart: "Add to Cart", add_to_fav: "Add to Favorites", stock: "Stock", in_stock: "In stock", out_of_stock: "Out of stock", sku: "SKU", code: "Code", price: "Price", related: "Related Products", features: "Features", description: "Description" },
    cart: { title: "My Cart", empty: "Your cart is empty", subtotal: "Subtotal", shipping: "Shipping", total: "Total", checkout: "Checkout", continue: "Continue Shopping", remove: "Remove", qty: "Qty" },
    checkout: { title: "Checkout", address: "Shipping Address", payment: "Payment Method", bank: "Bank Transfer", place_order: "Place Order", success: "Order placed!", full_name: "Full Name", phone: "Phone", city: "City", district: "District", addr_text: "Address", postal: "Postal Code", addr_title: "Address Label" },
    auth: { login_title: "Sign In", register_title: "Register", email: "Email", password: "Password", name: "Your Name", submit_login: "Sign In", submit_register: "Register", no_account: "Don't have an account?", have_account: "Already a member?" },
    rates: { title: "Currency & Gold Prices", sub: "Live rates from TCMB and Nadir Döviz", currency: "Currency", gold: "Gold", silver: "Silver", buy: "Buy", sell: "Sell", last_update: "Last update" },
    tv: { live: "LIVE", currencies: "CURRENCY", gold: "GOLD", silver: "SILVER" },
    admin: { dashboard: "Dashboard", products: "Products", categories: "Categories", orders: "Orders", customers: "Customers", settings: "Settings", margins: "Margins", homepage: "Homepage", add_product: "Add Product", add_category: "Add Category", save: "Save", cancel: "Cancel", edit: "Edit", delete: "Delete", name: "Name", price: "Price", stock: "Stock", status: "Status", actions: "Actions" },
    common: { view_details: "View Details", view_all: "View All", loading: "Loading...", search: "Search products...", sort: "Sort", filter: "Filter" },
  },
};

export function t(lang, key) {
  const parts = key.split(".");
  let obj = TRANSLATIONS[lang] || TRANSLATIONS.tr;
  for (const p of parts) {
    if (obj == null) return key;
    obj = obj[p];
  }
  return obj || key;
}
